export default function getResponseErrors(err: any): string {
  if (err?.response?.data?.validation?.body?.message)
    return err?.response?.data?.validation?.body?.message;
  if (err?.response?.data?.message) return err?.response?.data?.message;
  return err.message;
}
